import React from "react";
import { useNavigate } from "react-router-dom";
import { ReportsLayout } from "../layout/ReportsLayout";
import { REPORTS_NAV_SECTIONS } from "../config/reportsNavigation";

/**
 * `/reports` landing: one line and the same three reports the rail shows, as
 * cards. Section headings and "coming soon" states only render if the nav
 * config grows again.
 */
export const ReportsOverviewPage: React.FC = () => {
  const navigate = useNavigate();
  const sections = REPORTS_NAV_SECTIONS.filter((s) => s.id !== "overview");

  return (
    <ReportsLayout>
      <div className="flex w-full flex-col gap-8">
        <div className="flex flex-col gap-2">
          <span className="text-heading-2 font-heading-2 text-default-font">Reports</span>
          <span className="max-w-2xl text-body font-body text-subtext-color">
            Profit and Loss, Balance Sheet and Cash Flow Statement from Zoho Books.
          </span>
        </div>

        {sections.map((section) => (
          <div key={section.id} className="flex flex-col gap-3">
            {section.label && (
              <span className="text-caption-bold font-caption-bold uppercase tracking-wide text-subtext-color">
                {section.label}
              </span>
            )}
            <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
              {section.items.map((item) => {
                const available = item.to !== undefined;
                return (
                  <button
                    key={item.id}
                    type="button"
                    disabled={!available}
                    title={available ? undefined : "Coming soon"}
                    onClick={() => item.to && navigate(item.to)}
                    className={
                      available
                        ? "flex flex-col items-start gap-1 rounded-md border border-solid border-neutral-border bg-default-background px-4 py-3 text-left transition-colors hover:border-brand-primary hover:bg-neutral-50"
                        : "flex cursor-not-allowed flex-col items-start gap-1 rounded-md border border-dashed border-neutral-border bg-neutral-50 px-4 py-3 text-left"
                    }
                  >
                    <span
                      className={
                        available
                          ? "text-body-bold font-body-bold text-default-font"
                          : "text-body-bold font-body-bold text-neutral-400"
                      }
                    >
                      {item.label}
                    </span>
                    {!available && (
                      <span className="text-caption font-caption text-subtext-color">Coming soon</span>
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </ReportsLayout>
  );
};
